"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.filter.dateFrom': 'Data od',
    'dblogs.filter.dateTo': 'Data do',
    'dblogs.filter.models': 'Modele',
    'dblogs.filter.models.placeholder': 'Wszystkie modele',
    'dblogs.filter.operations': 'Operacje',
    'dblogs.filter.operations.placeholder': 'Wszystkie operacje',
    'dblogs.filter.recordIds': 'ID rekordów',
    'dblogs.filter.recordIds.placeholder': 'Dodaj wartość klawiszem Enter',
    'dblogs.filter.search': 'Szukaj',
};
